import EventsPage from './eventsPage.component';

export default EventsPage;